import SmartImg from "@/lib/img";

const PROM_URL = "https://templebethelwpb.shulcloud.com/event/prom";

export default function PromBanner({ topSlot = false }) {
  return (
    <section
      aria-label="Midnight at Memory Lane — Prom Night, Saturday February 7"
      data-testid="prom-banner"
      className={`relative overflow-hidden border-y border-gold/30 bg-ink flex items-center ${topSlot ? "h-full pt-24 md:pt-28" : ""}`}
    >
      <a
        href={PROM_URL}
        data-testid="prom-banner-link"
        aria-label="Register for Prom Night — Midnight at Memory Lane, Saturday February 7"
        className="block w-full max-w-[1400px] mx-auto px-4 md:px-8 py-4 md:py-6"
      >
        <SmartImg
          src="/img/firstparty/prom-banner.webp"
          sizes="(max-width: 1050px) 100vw, 1050px"
          alt="Midnight at Memory Lane — Prom Night, Saturday February 7. Dinner, dancing and live music featuring The Ladies of Memory Lane. $50 per person, $85 per couple. Scan the QR code or visit templebethelwpb.shulcloud.com/event/prom to register."
          fetchPriority="high"
          width={1050}
          height={350}
          className="block mx-auto w-full max-w-[1050px] h-auto border border-gold/20 hover:border-gold/50 transition-colors duration-500"
        />
      </a>
    </section>
  );
}
